export default __webpack_public_path__ + "static/media/spinner.e86bb673.gif";